import { PermissionT } from "../types";

export const masterDealer = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "master_dealer");
  return !!p;
};
export default masterDealer;
